import React from "react";
import { Link } from "react-router-dom";
import ArrowCircleRight from "../arrow-circle-right";
import ContactUs from "../contact-us";
import Card from "./card";
import Hero from "./Hero/index";

const HomePage = () => {
  return (
    <main className="max-w-screen-xl mx-auto ">
      <Hero />
      {/* communcation tools */}
      <section className="mt-20 px-6 md:px-0">
        <h3 className="text-primary font-semibold text-xl md:text-5xl text-center">
          Enjoy Access to Powerful Communication Tools
        </h3>
        <h4 className="text-xs md:text-2xl text-center my-2">
          Powerful Communication Solutions for your Business
        </h4>
        <p className="text-center text-[10px] md:text-base font-light">
          At SleengShort, we’re more than just a Communication platform – we’re
          your partner in growth. Here’s why thousands of businesses trust us:
        </p>

        <div className="flex md:flex-row flex-col pt-10 gap-4 px-2 md:px-0">
          {[
            {
              img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744332102/send-otp_y3qnq4.png",
              title: "Send Automated Mass Text Messages Effortlessly",
              path: "/bulk-sms",
              description:
                "Deliver crucial information, promotional offers, and updates to thousands of recipients instantly. Our robust platform ensures high delivery rates and seamless integration.",
            },
            {
              img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744332091/self-service_pxiait.png",
              title: "Interactive Mobile Services at Your Fingertips",
              path: "/ussd",
              description:
                "Leverage USSD for interactive menus, data collection, mobile surveys, and more. Provide real-time information and services to your customers, even without internet access.",
            },
            {
              img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744332104/new-message_by65sj.png",
              title: "Target and Engage Your Audience with Precision",
              path: "/campaigns",
              description:
                "Create personalized SMS campaigns to drive sales, promote events, and gather feedback. Segment your audience and deliver relevant messages for maximum impact.",
            },
          ].map((tool, index) => (
            <Link to={tool.path}>
              <div
                key={index}
                className="flex flex-col items-center gap-4 min-w-80 bg-[#EAEAEA] md:min-h-[520px] rounded-lg"
              >
                <img
                  src={tool.img}
                  alt="Avatar"
                  className={`w-[560px] object-cover  pt-4 pl-4 ${
                    index !== 2 && ""
                  }  mt-2 h-80`}
                />
                <div className="p-4">
                  <h6 className="text-sm md:text-base font-bold">
                    {tool.title}
                  </h6>
                  <p className=" text-xs md:text-sm mt-2 font-light text-[15px]">
                    {tool.description}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
      {/* why choose us */}
      <section className="md:mt-20 mt-14 container  px-6 md:px-10 md:px-0">
        <h3 className="text-primary font-semibold text-xl md:text-5xl text-center pb-4">
          Why Chose Sleengshort ?
        </h3>
        <h4 className="text-xs md:text-2xl text-center md:pb-4 pb-2">
          Powerful Communication Solutions for your Business
        </h4>
        <p className="text-center font-light text-[10px] md:text-base">
          At SleengShort, we’re more than just a Communication platform – we’re
          your partner in growth. Here’s why thousands of businesses trust us:
        </p>{" "}
        <div className="grid md:grid-cols-3 grid-cols-2 pt-10 gap-4">
          {[
            {
              title: "99% Delivery Rate",
              description: "Ensure your messages reach their destination.",
              img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744332092/why-choose-1_rzf2w9.png",
            },
            {
              title: "Affordable Pricing",
              description: "Cost-effective plans tailored to your needs.",
              img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744332094/why-choose-2_v5rs0a.png",
            },
            {
              title: "Easy-to-Use Tools",
              description: "Intuitive interface for hassle-free messaging.",
              img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744332123/why-choose-3_egmtzj.png",
            },
            {
              title: "Real time Analytics",
              description:
                "Get real-time  report on customer engagements across board ",
              img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744332124/why-choose-4_wwtqei.png",
            },
            {
              title: "24/7 Support",
              description: "Dedicated assistance whenever you need it.",
              img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744332084/why-choose-5_gbzael.png",
            },
          ].map((item, index) => (
            <Card
              key={index}
              img={item.img}
              title={item.title}
              description={item.description}
            />
          ))}
          <div className="bg-[#DCE7FE] rounded-xl w-full p-2 md:p-10 space-y-2 md:space-y-4">
            <p className="text-primary text-sm md:text-3xl font-semibold">
              Ready to Transform Your Business Communication?
            </p>
            <p className="font-light md:pb-10 text-xs md:text-base">
              Sign up now and experience the power of instant messaging.
            </p>
            <div className="sm:block hidden">
              <ArrowCircleRight />
            </div>
          </div>
        </div>
      </section>

      {/* plug in with ease */}
      <div className="px-4 md:px-10 md:mt-28 mt-14">
        <section
          style={{
            backgroundImage: `url('https://res.cloudinary.com/dbpb7sjus/image/upload/v1744332083/plug-with-ease_nn5wt9.png')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
          className="bg-[#002347] rounded-lg p-6 md:pl-10 md:pr-32 md:pt-12 md:pb-24 space-y-3"
        >
          <h3 className="text-white text-xl md:text-6xl font-semibold">
            Plug in with ease
          </h3>
          <h4 className="text-secondary text-base md:text-3xl font-medium">
            Seamless Integration with Our Powerful SMS API
          </h4>
          <p className="text-white text-xs md:text-xl font-light">
            Integrate SleengShort's robust SMS capabilities directly into your
            applications and systems. Our developer-friendly API allows you to
            automate messaging, enhance customer interactions, and streamline
            your workflows.
          </p>
          <div className="flex md:flex-col gap-3 md:gap-6 md:w-[40rem] md:!mt-10">
            <div className="flex flex-col">
              <div className="flex gap-2">
                <button className="py-2 w-[156px] md:w-fit md:py-4 pl-[4px] md:px-4 bg-white text-xs text-black md:text-[20px] font-medium rounded flex items-center justify-center gap-1">
                  <span>send and receive SMS</span>
                  <img
                    className="w-[14px] md:w-[30px] md:ml-4"
                    src="https://res.cloudinary.com/dbpb7sjus/image/upload/v1744332082/send-icon_eqyeqs.png"
                    alt="send icon"
                  />
                </button>
                <button className="py-2 w-[156px] md:w-fit  md:py-4 pl-[4px]  md:px-4 bg-white text-xs text-black md:text-[20px] font-medium rounded flex items-center justify-center gap-1">
                  <span>manage Contacts</span>
                  <img
                    className="w-[14px] md:w-[30px] md:ml-4"
                    src="https://res.cloudinary.com/dbpb7sjus/image/upload/v1744332082/contact-icon_y9ukdk.png"
                    alt="contact icon"
                  />
                </button>
              </div>
              <button className="py-2 md:w-fit mt-4 w-fit  pl-[4px]  md:py-4  md:px-4 bg-white text-xs text-black md:text-[20px] font-medium rounded flex items-center gap-1">
                <span>track delivery reports with</span>
                <img
                  className="w-[14px] md:w-[30px] md:ml-4"
                  src="https://res.cloudinary.com/dbpb7sjus/image/upload/v1744332081/analytics-icon_lp4nfh.png"
                  alt="analytics icon"
                />
              </button>
            </div>
          </div>
          <button className="bg-secondary text-white font-medium py-2 px-3.5 rounded float-right hidden md:block">
            View API Documentation
          </button>
        </section>
      </div>

      {/* tailored solutions */}
      <section className="mt-14 md:mt-20 px-6 md:px-16">
        <h3 className="text-primary font-semibold text-xl md:text-5xl text-center pb-4">
          Tailored Solution for every Industry
        </h3>
        <h4 className="text-center pb-4 text-sm md:text-base">
          SleengShort's versatile SMS and USSD solutions adapt to the unique
          needs of diverse industries.
        </h4>
        <div className="mt-10 space-y-6">
          {[
            {
              title: "Service & Operations (Finance, Logistics, Healthcare)",
              descr:
                "Streamline operations with real-time alerts, confirmations, and critical updates, ensuring efficiency and reliability.",
              img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744332089/tailored-solutions-1_t4rdk9.png",
            },
            {
              title:
                "Customer-Facing Businesses (Retail, Hospitality, E-commerce)",
              descr:
                "Drive engagement, send promotions, and provide instant updates, enhancing customer experiences and boosting sales.s",
              img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744332089/tailored-solutions-2_tq9t9v.png",
            },
            {
              title: "Public & Community (Education, Government)",
              descr:
                "Deliver vital information, announcements, and emergency notifications, fostering effective communication within communities and institutions.",
              img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744332090/tailored-solutions-3_tscmjf.png",
            },
            {
              title: "Marketing & Engagement (All Sectors)",
              descr:
                "Conduct targeted campaigns, gather feedback, and enhance brand awareness with personalized SMS and USSD interactions.",
              img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744332096/tailored-solutions-4_xmfkf1.png",
            },
          ].map((item, i) => (
            <div
              key={i}
              className="flex h-[150px] md:h-fit w-fit items-center bg-[#EAEAEA] rounded-xl"
            >
              <div className="p-4 md:p-16 w-[60%] space-y-4 md:space-y-14">
                <p className="text-xs md:text-2xl font-semibold">
                  {item.title}
                </p>
                <p className="text-[10px] md:text-base">{item.descr}</p>
              </div>
              <div className="  w-[30%] flex-1 h-[100%]">
                <img
                  src={item.img}
                  alt={item.title}
                  className="md:h-full h-full w-full
                  rounded-tr-xl rounded-br-xl
                  md:w-full md:block flex-1 object-cover"
                />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* contact us */}
      <ContactUs />
    </main>
  );
};

export default HomePage;
